export default __webpack_public_path__ + "static/media/img4.ab50ac77.png";